/**
 * Created by guwei on 2017/12/10.
 */
var toast = require('@hb/hb-toast/index.js');
var customlog = require('@hb/hb-customlog/index.js');
var bridge4Js = function () {
    return this;
}
bridge4Js.prototype.callCHandler = function (obj4Fun) {
    this._setupWebViewJavascriptBridge(function (bridge) {
        if(!bridge){
            toast.inform('客户端脚本注册失败,请重试');
            customlog('客户端注入脚本', '请求客户端的脚本失败');
        }
        bridge.callHandler('WebViewJavascriptBridgeRun', {
            'nativeMethod': obj4Fun.nativeMethod,
            'data': obj4Fun.data || {}
        }, function (response) {
            //response是个字符串，因此这里需要转成Json
            var responseObj = {};
            try {
                responseObj = JSON.parse(response);
            } catch (e) {
                customlog('调用客户端方法失败', e.message);
            }

            typeof obj4Fun.callBack === 'function' && obj4Fun.callBack.call(this, responseObj);
        })
    })
}
//发起请求，请求客户端注入brige脚本
bridge4Js.prototype._setupWebViewJavascriptBridge = function (callback) {
    if (window.WebViewJavascriptBridge) {
        return callback(WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];

    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe)
    }, 0)
}
module.exports = new bridge4Js();


